// hooks/useGrupos.js
import { useQuery } from '@tanstack/react-query';
import { API } from '../../../helpers/API';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const QUERY_KEY = 'properties';

const fetchData = () => async () => {
  const res = await API.GET('articulos/listPropieties');
  return res?.errors.data;
};

export const useGrupos = () => {
  const queryProperties = useQuery({
    queryKey: [QUERY_KEY],
    queryFn: fetchData(),
    staleTime: 1000 * 5,
    gcTime: 1000 * 10,
  });

  let parsedGrupos = [];
  try {
    const rawGrupos = cookies.get('grupos');
    const parsed = JSON.parse(rawGrupos);
    parsedGrupos = Array.isArray(parsed) ? parsed : [];
  } catch {
    parsedGrupos = [];
  }

  return {
    ...queryProperties,
    cookies: {
      grupos: parsedGrupos,
    },
  };
};
